import { connectRouter, routerMiddleware } from 'connected-react-router';
import { History } from 'history';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { reducers } from './';

export default function configureStore(history: History) {
    const middleware = [
        thunk,
        routerMiddleware(history)
    ];

    const persistConfig = {
        key: 'root',
        storage
    }

    const rootReducer = combineReducers({
        ...reducers,
        router: connectRouter(history)
    });
    const persistedReductr = persistReducer(persistConfig, rootReducer);


    const enhancers = [];
    const windowIfDefined = typeof window === 'undefined' ? null : window as any;
    if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
    }

    const store = createStore(
        persistedReductr,
        compose(applyMiddleware(...middleware), ...enhancers)
    );

    const persistor = persistStore(store)

    return { store, persistor };
}
